module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_FI-02-03a87ce7beb77cd9106e7a6fc638a852.svg";